const zh = {
    header:{
        home: "首页"
    }
}

export default  zh;